class MutationsFactory {
  private data: object[]

  constructor(data: object[]) {
    this.data = data
  }

  compositeData(chunkSize: number): object[] {
    var R = [];
    for (var i = 0; i < this.data.length; i += chunkSize)
      R.push(this.data.slice(i, i + chunkSize));
    return R;
  }
}

class LocalPersistence {
  private key: string
  private body: object | boolean | undefined

  constructor(key: string, body?: object | boolean | undefined) {
    this.key = key
    this.body = body
  }

  async setLocalPersistence() {
    const setLocal = await window.localStorage.setItem(this.key, JSON.stringify(this.body))
    return setLocal
  }

  async setSessionPersistence() {
    const setSession = await window.sessionStorage.setItem(this.key, JSON.stringify(this.body))
    return setSession
  }

  async getLocalPersistence() {
    const getLocal: object | any = await window.localStorage.getItem(this.key)
    const JSONresponse = JSON.parse(getLocal)
    return JSONresponse
  }

  async getSessionPersistence() {
    const getSession: object | any = await window.sessionStorage.getItem(this.key)
    const JSONresponse = JSON.parse(getSession)
    return JSONresponse
  }

  async updateLocalPersistence(data: object) {
    this.body = {...data}
    return this.setLocalPersistence()
  }

  async updateSessionPersistence(data: object) {
    this.body = {...data}
    return this.setSessionPersistence()
  }

  async removeLocalPersistence() {
    return await window.localStorage.removeItem(this.key)
  }

  async removeSessionPersistence() {
    return await window.sessionStorage.removeItem(this.key)
  }

}

export {
  MutationsFactory,
  LocalPersistence
}
